import { Grid, Link } from '@material-ui/core';
import { CloseOutlinedIcon } from 'components/icons/close-outlined';
import ASBVPercentileTable from 'pages/search/asbvs/asbv-percentile-table';
import { ShowPercentile } from 'pages/search/asbvs/asbvs-utils';
import React, {
  useEffect, useRef, useState,
} from 'react';
import { RelativeTooltipProps } from './relative-tooltip-props';
import './relative-tooltip.scss';

export const RelativeTooltip: React.FC<RelativeTooltipProps> = (props) => {
  const {
    content,
  } = props;
  const [columnsAmount, setColumnsAmount] = useState<any>(6);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const onClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  useEffect(() => {
    if (content) {
      setColumnsAmount(12 / content?.sections?.length || 1);
    }
  }, [content]);

  return (
    <>
      {!!content && (
        <div
          className="sg-relative-tooltip container-padding"
          ref={tooltipRef}
        >
          <h5 className="sg-relative-tooltip__title">{content.title}
            <CloseOutlinedIcon
              className="sg-relative-tooltip__close"
              onClick={() => onClose()}
            />
          </h5>
          <Grid
            item
            xs={12}
            sm={8}
          >
            <p className="sg-relative-tooltip__summary">{content.summary}</p>
          </Grid>

          <Grid
            className="sg-relative-tooltip__content-container"
            container
          >
            {content.sections.map((section: any, i: number) => (
              <Grid
                item
                xs={12}
                sm={content.tabletColumns[i]}
                md={content.desktopColumns ? content.desktopColumns[i] : columnsAmount}
                key={section.type || Math.random()}
              >
                <h6>{section.type}</h6>
                <div className="sg-relative-tooltip__section">
                  <div className="sg-relative-tooltip__images">
                    {section.image && section.image.map((imgPath: string) => (
                      <img
                        src={imgPath}
                        alt={section.type}
                        key={imgPath}
                      />
                    ))}
                  </div>
                  <span className="sg-relative-tooltip__content">
                    {section.content.desc && section.content.desc.map((paragraph: string) => (<p key={Math.random()}>{paragraph}</p>))}
                    <ul className="sg-relative-tooltip__list">
                      {section.content.list && section.content.list.map((listItem: string) => (
                        <li
                          key={listItem}
                          dangerouslySetInnerHTML={{ __html: listItem }}
                        />
                      ))}
                    </ul>
                  </span>
                  {section.content.link && (
                    <span className="sg-relative-tooltip__link">
                      <Link
                        className="lower"
                        href="https://www.sheepgenetics.org.au/getting-started/asbvs-and-indexes/"
                        target="_blank"
                        rel="noopener"
                      >
                        View more information
                      </Link>
                    </span>
                  )}
                </div>
              </Grid>
            ))}
            <Grid
              item
              xs={12}
              key={Math.random()}
            >
              <span className="sg-relative-tooltip__content">
                {(props.content?.asbv)
                  && (ShowPercentile(props.content?.asbv))
                  && (
                    <ASBVPercentileTable
                      asbv={props.content?.asbv}
                      filterPercentiles
                    />
                  )}
              </span>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

// (ExternalTooltip as any).whyDidYouRender = true;
